import {
  Tooltip,
  IconButton,
  Typography,
  Link,
  Box,
  SxProps,
  Theme,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LaunchIcon from '@mui/icons-material/LaunchOutlined';

interface HelperTooltipProps {
  tooltipData: {
    type: string;
    tooltipText?: string;
    ctaName?: string;
    url?: string;
    isVisible?: boolean;
  };
  sx?: SxProps<Theme>;
  iconAdjust?: string;
}

export default function HelperTooltip({
  tooltipData,
  sx,
  iconAdjust,
}: HelperTooltipProps) {
  const { type, tooltipText, ctaName, url, isVisible } = tooltipData;

  if (type === 'tooltip' && isVisible) {
    return (
      <Tooltip
        arrow
        enterDelay={100}
        leaveDelay={250}
        disableInteractive={false}
        sx={sx}
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -8],
              },
            },
          ],
        }}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'transparent',
              padding: 0,
              filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
              '& .MuiTooltip-arrow': {
                color: '#FFFFFF',
              },
            },
          },
        }}
        placement="top"
        title={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              background: 'white',
              px: '25px',
              py: '23px',
              borderRadius: '3px',
            }}
          >
            {tooltipText && (
              <Typography
                sx={{
                  mb: ctaName ? 1 : 0,
                  fontSize: '12px',
                  fontWEight: '400',
                  lineHeight: '20px',
                  color: '#3B455E',
                }}
              >
                {tooltipText}
              </Typography>
            )}

            {ctaName && url && (
              <Link
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
                width="fit-content"
                sx={{
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '12px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  color: '#447EEB',
                  gap: '4px',

                  borderBottom: '1px solid transparent',
                  pb: '1px',

                  '&:hover': {
                    borderBottomColor: 'currentColor',
                  },
                }}
              >
                {ctaName}
                <LaunchIcon sx={{ fontSize: '12px' }} />
              </Link>
            )}
          </Box>
        }
      >
        <IconButton size="small" sx={{ p: 0.5, mt: iconAdjust ?? '-13px' }}>
          <HelpOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  if (type === 'directLink' && isVisible) {
    return (
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
        width="fit-content"
        sx={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '14px',
          display: 'inline-flex',
          alignItems: 'center',
          color: '#447EEB',
          gap: '4px',

          borderBottom: '1px solid transparent',
          pb: '10px',

          '&:hover': {
            borderBottomColor: 'currentColor',
          },
          ...sx,
        }}
      >
        {ctaName}
        <LaunchIcon sx={{ fontSize: '12px' }} />
      </Link>
    );
  }

  return null;
}
